export const getSetupBy = (email, name) => {
    return name ? `${name} (${email})` : email;
};
